module.exports = __webpack_public_path__ + "img/fav.df585777.svg";